import { render, staticRenderFns } from "./traningInfo.vue?vue&type=template&id=9ca739ca"
import script from "./traningInfo.vue?vue&type=script&lang=js"
export * from "./traningInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ca739ca')) {
      api.createRecord('9ca739ca', component.options)
    } else {
      api.reload('9ca739ca', component.options)
    }
    module.hot.accept("./traningInfo.vue?vue&type=template&id=9ca739ca", function () {
      api.rerender('9ca739ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/eap/traningInfo.vue"
export default component.exports